import { useCallback } from 'react';

import { useQueryClient } from '@tanstack/react-query';

import { UserEndpoints } from '@src/entities';
import { RequestMethods, useRequest } from '@src/shared';
import type { CommonResponse } from '@src/shared/types';
import type { RequestDeps } from '@src/shared/types/request.types';

import type { RefreshCodeResponse } from './refresh-code.types';

type useRefreshCodeProps = {
  phone?: string;
  deps?: RequestDeps;
  fetchManual?: boolean;
};

export const useRefreshCode = ({
  phone,
  deps,
  fetchManual = true,
}: useRefreshCodeProps) => {
  const queryClient = useQueryClient();
  const key = 'refresh-code';
  const { res, isLoading, refetch, error, status, isFetching, isRefetching } =
    useRequest<never, RefreshCodeResponse, CommonResponse>({
      params: {
        key,
        method: RequestMethods.GET,
        url: `${UserEndpoints.USERS}/${phone}/refresh-code/otp`,
        fetchManual: fetchManual,
        deps,
      },
    });

  const resetQueryErrorRefreshCode = useCallback(() => {
    queryClient.resetQueries({ queryKey: [key] });
  }, [queryClient]);

  return {
    res,
    error,
    isLoading,
    refetch,
    status,
    isFetching,
    isRefetching,
    resetQueryErrorRefreshCode,
  };
};
